// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

 const initialState = {
  isOpen: [], // for active default menu
  defaultId: 'default',
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  opened: true,
  isLoggedIn: false,
  user: null,
  error: null
};



// ==============================|| CUSTOMIZATION REDUCER ||============================== //

export const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius
      };
    default:
      return state;
  }
};


export const LoginReducer = (state = initialState, action) => {
  // const Nav=useNavigate()
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        error: null
      };
    case actionTypes.LOGIN_SUCCESS:
      // Nav(`/dashboard/default`)
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
        error: null

      }

    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        error: action.payload
      };
    default:
      return state;
  }
};

